import styled from '@emotion/styled';
import Button from '../Button/Button';
import theme from '../../themes/default';

export const ButtonContainer = styled(Button)`
  margin-right: ${theme.spacing.xLarge};
`;

export const FooterActionsContainer = styled('div')`
  display: flex;
  padding-left: 30px;
`;
